
import { defineComponent } from 'vue'
import { setLocale } from '@/localization'

export default defineComponent({
    name: "App",
    methods: {
        setLocale: function () {
            setLocale("fr_FR")
        }
    }
})
